export default __webpack_public_path__ + "static/media/plants.20909ae2.svg";